import { Injectable } from "@angular/core";
import { DataService } from '../../architecture/data.service';
import { Result } from '../../architecture/envelopes';
import { HttpParams } from '@angular/common/http';
import { WaiverRequestFilter } from 'src/app/shared/models/waiverrequestFilter.model';
import { UtilService } from 'src/app/shared/architecture/services/util.service';
import { AuthorizationExpiredFilter } from 'src/app/shared/models/authorizationexpiredFilter.model';

@Injectable({ providedIn: 'root' })
export class AuthorizationExpiredService {
    constructor(private dataService: DataService,
        private utilService: UtilService,
    ) { }

    public get(page: number, order: string, orderT: string, filter: AuthorizationExpiredFilter) {
        let params = new HttpParams()
            .set('filter.page', page.toString())
            .set('filter.entity.client', filter.clientId)
            .set('filter.entity.id', filter.id)
            .set('filter.orderByField', order)
            .set('filter.orderBy', orderT);;

        return this.dataService.get<Result<any>>("request/authorizationexpired", params);
    }

    public report(filter: AuthorizationExpiredFilter) {
        let body = {
            entity: {
                id: filter.id,
                client: filter.clientId
            }
        };

        this.utilService.DownloadFile("request/authorizationexpired/generatefile", "autorizações-vencidas.xlsx", body);
    }

    public reactivate(ids: any) {
        return this.dataService.post<Result<any>>("request/authorizationexpired/reactivate", ids);
    }
}
